// use this id on any page theres a coalition search
$('#coalition-search-submit').click(function (e) {
  $(this).parents('form').submit();
});